import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

interface ProfileComponentProps {}

const ProfileComponent: React.FC<ProfileComponentProps> = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading ...</div>;
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div>
      <img src={user.picture} alt={user.name} />
      <h2>{user.name}</h2>
      <p>{user.email}</p>
      <a href={process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL || '#'}>Manage Subscription</a>
    </div>
  );
};

export default ProfileComponent;
